import React from "react";
import { LessonNavigator as CoreLessonNavigator } from "@jelly/lesson";
import defaultStyle from "./LessonNavigator.module.scss";

export const LessonNavigator: React.FC<React.ComponentProps<typeof CoreLessonNavigator>> = (props) => {
  return <CoreLessonNavigator {...props} style={defaultStyle} />;
};
